/** AWS region config for Cognito Identity Pool direct uploads. Add new regions here; consumers use enum values, never string literals. */

export enum AWS_BUCKETS {
  SPEAKAI_STORAGE_DEFAULT = "speakai-storage",
  SPEAKAI_UPLOAD = "speakai-upload",
  SPEAKAI_STORAGE_US_EAST_1 = "speakai-storage-us-east-1",
  SPEAKAI_STORAGE_CA_CENTRAL_1 = "speakai-storage-ca-central-1",
  SPEAKAI_STORAGE_EU_CENTRAL_1 = "speakai-storage-eu-central-1",
}

export interface AwsRegionConfig {
  bucketName: AWS_BUCKETS;
  region: string;
  identityPoolId: string;
}

export const AWS_REGIONS: AwsRegionConfig[] = [
  // Index 0 is the canonical fallback bucket. Aligns with server default
  // (speak-server/src/@speak-common/middleware/is-auth.ts attaches
  //  bucketId = company?.subscription?.bucketId ?? SPEAKAI_STORAGE_US_EAST_1)
  //  and Angular default (angular-old/src/app/core/services/shared/s3upload.service.ts:44).
  {
    bucketName: AWS_BUCKETS.SPEAKAI_STORAGE_US_EAST_1,
    region: "us-east-1",
    identityPoolId: "us-east-1:ac6316c5-5a60-4585-a300-877ba1012725",
  },
  {
    bucketName: AWS_BUCKETS.SPEAKAI_STORAGE_DEFAULT,
    region: "us-east-1",
    identityPoolId: "us-east-1:ac6316c5-5a60-4585-a300-877ba1012725",
  },
  {
    bucketName: AWS_BUCKETS.SPEAKAI_STORAGE_CA_CENTRAL_1,
    region: "ca-central-1",
    identityPoolId: "ca-central-1:b6e6b298-e891-4cae-8e78-8608f851493b",
  },
];

/** Resolve region config by bucket id; falls back to SPEAKAI_STORAGE_US_EAST_1 (index 0) when unregistered. */
export function getAwsRegionConfig(
  bucketId?: AWS_BUCKETS | string,
): AwsRegionConfig {
  return (
    AWS_REGIONS.find((r) => r.bucketName === bucketId) ?? AWS_REGIONS[0]
  );
}
